<template>
  <Card>
    <AjaxForm route="admin/Message/Add" :callback="addCallback">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-4 mb-2">
          <CustomInput type="text" input_style="twoLine" name="subject" placeholder="موضوع را وارد کنید" label="موضوع"></CustomInput>
        </div>
        <div class="col-12 col-sm-12 col-md-4 mb-2">
          <CustomInput input_style="twoLine" label="میزان اهمیت" v-model="priority" type="select" name="priority" placeholder="اهمیت" select-label="title" reduce_select="value" :select-options="priority_option"></CustomInput>
        </div>
        <div class="col-12 col-sm-12 col-md-4 mb-2">
          <CustomInput input_style="twoLine" name="target" v-model="send_to" label="ارسال به" placeholder="ارسال به" type="select" select-label="title" reduce_select="value" :select-options="sendToOptions"></CustomInput>
        </div>
      </div>
      <div class="row" v-if="send_to && send_to.value === 'user'">
        <div class="col-12 col-sm-12 col-md-6">
          <CustomInput :selectFilter="userFilter" v-model="selected_user"
                       type="select" :without-label="true" :fetch-options="getUserForSelect"
                       select-label="title" reduce_select="_id" placeholder="جستجو کاربر" :select-options="user_options"></CustomInput>
        </div>
        <div class="col-12 col-md-4" v-for="(user,index) in users" :key="user">
          <div class="alert icon-custom-alert alert-outline-success">
            <div class="alert-text">
              {{user.title}}({{user.phone}})
              <input type="hidden" name="user_id[]" :value="user._id" hidden readonly>
            </div>
            <div class="alert-close">
              <button @click="removeUser(index)" type="button" class="close">
                <span aria-hidden="true"><i class="fal fa-times text-success font-16"></i></span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="send_to && send_to.value === 'guild'">
        <div class="col-12 col-sm-12 col-md-6">
          <CustomInput v-model="selected_guild" type="select"
                       :without-label="true"
                       placeholder="جستجو صنف"
                       :fetch-options="getGuildsForSelect"
                       select-label="title" reduce_select="_id"
                       :select-options="guild_options"></CustomInput>
        </div>
        <div class="col-12 col-md-4" v-for="(guild,index) in guilds" :key="guild">
          <div class="alert icon-custom-alert alert-outline-success">
            <div class="alert-text">
              {{guild.title}}
              <input type="hidden" name="guild_id[]" :value="guild._id" hidden readonly>
            </div>
            <div class="alert-close">
              <button @click="removeGuild(index)" type="button" class="close">
                <span aria-hidden="true"><i class="fal fa-times text-success font-16"></i></span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="my-2">
        <label>متن پیام : </label>
        <input type="hidden" name="content" v-model="content" hidden readonly >
        <editor v-model="content" api-key="f60dl4sz819mfm6cps7g9825ms3y9brgz2hlbiwc610e2mbd"
                :init="{
                     language: 'fa',
                     directionality : 'rtl',
                     menubar: false,
                     toolbar:
                     'undo redo | formatselect | bold italic backcolor | \
                     alignright aligncenter alignleft alignjustify | \
                     bullist numlist outdent indent | removeformat'}"
        ></editor>
      </div>
      <div class="row">
        <div class="col-10 col-sm-9 col-md-5 mx-auto">
          <button class="btn btn-info btn-block" type="submit">ثبت پیام</button>
        </div>
      </div>
    </AjaxForm>
  </Card>
</template>

<script>
import Card from "@/components/forms/Card";
import {AppApi} from "@/api/AppApi";
import {mapActions} from "vuex";
import CustomInput from "@/components/CustomInput";
import {ProductApi} from "@/api/ProductApi";
import {searchInObjArray, showSystemNoti, showToast} from "@/shared/helper";
import Editor from '@tinymce/tinymce-vue'
import AjaxForm from "@/components/forms/AjaxForm";
export default {
  name: "UserMessageAdd",
  components: {AjaxForm, CustomInput, Card,Editor},
  data()
  {
    return{
      content : '',
      priority_option : [
        {title :'عادی',value : 'normal'},
        {title :'مهم',value : 'important'},
        {title :'خیلی مهم',value : 'very_important'}
      ],
      sendToOptions:[
        {title :'همه',value : 'all'},
        {title :'صنف انتخابی',value : 'guild'},
        {title :'کاربر انتخابی',value : 'user'}
      ],
      selected_guilds : [],
      selected_guild : [],
      selected_users : [],
      selected_user : [],
      user_options : [],
      guild_options : [],
      priority : null,
      send_to : null,
      users : [],
      guilds : [],
    }
  },
  async mounted()
  {
    this.content = '';
    this.setPageLoading(false);
    this.setPageTitle('افزودن پیام جدید');
    this.setShowHead(true);
  },
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
    async getGuildsForSelect(search,loading)
    {
      loading(true);
      if (search.length > 1)
      {
        const data = await ProductApi.getGuildForSelectAjax(search);
        if (data.ok)
        {
          this.guild_options = data.guilds;
        }
        else
          this.guild_options = [];
      }
      loading(false);
    },
    async getUserForSelect(search,loading)
    {
      loading(true);
      if (search.length)
      {
        const data = await AppApi.getUserForSelectAjax(search);
        if (data.ok)
        {
          this.user_options = data.users;
        }
        else
          this.user_options = [];
      }
      loading(false);
    },
    async userFilter(options, search)
    {
      return options.filter(option => {
        let label = this.getOptionLabel(option);
        if (typeof label === "number") {
          label = label.toString();
        }
        return this.filterBy(option, label, search);
      });
    },
    removeUser(index)
    {
      this.users.splice(index,1);
    },
    removeGuild(index)
    {
      this.guilds.splice(index,1);
    },
    addToUsers()
    {
      const user = this.selected_user;
      if (user)
      {
        const check = searchInObjArray(user._id,this.users,'_id');
        if (!check)
          this.users.push(user);
        this.selected_user = null;
      }

    },
    addToGuilds()
    {
      const guild = this.selected_guild;
      if (guild)
      {
        const check = searchInObjArray(guild._id,this.guilds,'_id');
        if (!check)
          this.guilds.push(guild);
        this.selected_guild = null;
      }

    },
    addCallback(data)
    {
      if (data.ok)
      {
        showToast('success',data.message);
        this.$router.push({path : '/UserMessage/List'})
      }
      else
          showSystemNoti('danger',data.error);
    }
  },
  watch:{
    'selected_user':{
      handler(user)
      {
        if (user)
        {
          this.addToUsers();
        }
      }
    },
    'selected_guild':{
      handler(guild)
      {
        if (guild)
        {
          this.addToGuilds();
        }
      }
    },
  }
}
</script>

<style scoped>

</style>